export default {
 lang_name: '한국어',

 // Tabs
 tab_mine: '채굴',
 tab_upgrade: '강화',
 tab_prestige: '환생',
 tab_achievement: '업적',
 tab_settings: '설정',

 // HUD
 hud_cps: '/s',
 hud_tap: '/tap',
 hud_combo: 'x',

 // Main screen - actions
 action_daily_bonus: '일일보너스',
 action_turbo: '터보',
 action_ad_boost: '광고 부스트',

 // Generator names (fallback i18n keys mapped from config id)
 gen_gen1: '스마트폰 채굴',
 gen_gen2: '노트북 채굴',
 gen_gen3: '데스크탑 채굴',
 gen_gen4: 'GPU 리그',
 gen_gen5: 'ASIC 채굴기',
 gen_gen6: '채굴 농장',
 gen_gen7: '데이터센터',
 gen_gen8: '양자컴퓨터',
 gen_gen9: 'AI 채굴봇',
 gen_gen10: '위성 채굴기',
 gen_gen11: '달 채굴 기지',
 gen_gen12: '은하 채굴 네트워크',

 // Generator themes
 gen_gen1_theme: '주머니 속 부업',
 gen_gen2_theme: '카페 코인 농부',
 gen_gen3_theme: 'PC방 알바',
 gen_gen4_theme: '그래픽카드 대란',
 gen_gen5_theme: '전문 장비',
 gen_gen6_theme: '컨테이너 농장',
 gen_gen7_theme: '기업급 인프라',
 gen_gen8_theme: '미래 기술',
 gen_gen9_theme: '자율 채굴',
 gen_gen10_theme: '우주 확장',
 gen_gen11_theme: '달 정복',
 gen_gen12_theme: '우주 지배',

 // Locked
 locked: '잠김',

 // Upgrade categories
 upg_cat_generator: '생산기 업그레이드',
 upg_cat_global: '글로벌 업그레이드',
 upg_cat_research: '연구',
 upg_cat_darkpool: '다크풀',
 upg_empty: '업그레이드가 아직 해금되지 않았습니다',
 upg_empty_hint: '생산기를 구매하면 업그레이드가 나타납니다',

 // Upgrade names (mapped from config id)
 // Generator upgrades: up_{genId}_t{1,2,3}
 upg_up_gen1_t1: '스마트폰 효율화', upg_up_gen1_t1_desc: '스마트폰 채굴 효율 2배',
 upg_up_gen1_t2: '스마트폰 특화', upg_up_gen1_t2_desc: '스마트폰 채굴 효율 2배',
 upg_up_gen1_t3: '스마트폰 마스터', upg_up_gen1_t3_desc: '스마트폰 채굴 효율 2배',
 upg_up_gen2_t1: '노트북 효율화', upg_up_gen2_t1_desc: '노트북 채굴 효율 2배',
 upg_up_gen2_t2: '노트북 특화', upg_up_gen2_t2_desc: '노트북 채굴 효율 2배',
 upg_up_gen2_t3: '노트북 마스터', upg_up_gen2_t3_desc: '노트북 채굴 효율 2배',
 upg_up_gen3_t1: '데스크탑 효율화', upg_up_gen3_t1_desc: '데스크탑 채굴 효율 2배',
 upg_up_gen3_t2: '데스크탑 특화', upg_up_gen3_t2_desc: '데스크탑 채굴 효율 2배',
 upg_up_gen3_t3: '데스크탑 마스터', upg_up_gen3_t3_desc: '데스크탑 채굴 효율 2배',
 upg_up_gen4_t1: 'GPU 효율화', upg_up_gen4_t1_desc: 'GPU 채굴 효율 2배',
 upg_up_gen4_t2: 'GPU 특화', upg_up_gen4_t2_desc: 'GPU 채굴 효율 2배',
 upg_up_gen4_t3: 'GPU 마스터', upg_up_gen4_t3_desc: 'GPU 채굴 효율 2배',
 upg_up_gen5_t1: 'ASIC 효율화', upg_up_gen5_t1_desc: 'ASIC 채굴 효율 2배',
 upg_up_gen5_t2: 'ASIC 특화', upg_up_gen5_t2_desc: 'ASIC 채굴 효율 2배',
 upg_up_gen5_t3: 'ASIC 마스터', upg_up_gen5_t3_desc: 'ASIC 채굴 효율 2배',
 upg_up_gen6_t1: '농장 효율화', upg_up_gen6_t1_desc: '농장 채굴 효율 2배',
 upg_up_gen6_t2: '농장 특화', upg_up_gen6_t2_desc: '농장 채굴 효율 2배',
 upg_up_gen6_t3: '농장 마스터', upg_up_gen6_t3_desc: '농장 채굴 효율 2배',
 upg_up_gen7_t1: '데이터센터 효율화', upg_up_gen7_t1_desc: '데이터센터 채굴 효율 2배',
 upg_up_gen7_t2: '데이터센터 특화', upg_up_gen7_t2_desc: '데이터센터 채굴 효율 2배',
 upg_up_gen7_t3: '데이터센터 마스터', upg_up_gen7_t3_desc: '데이터센터 채굴 효율 2배',
 upg_up_gen8_t1: '양자컴퓨터 효율화', upg_up_gen8_t1_desc: '양자컴퓨터 채굴 효율 2배',
 upg_up_gen8_t2: '양자컴퓨터 특화', upg_up_gen8_t2_desc: '양자컴퓨터 채굴 효율 2배',
 upg_up_gen8_t3: '양자컴퓨터 마스터', upg_up_gen8_t3_desc: '양자컴퓨터 채굴 효율 2배',
 upg_up_gen9_t1: 'AI봇 효율화', upg_up_gen9_t1_desc: 'AI봇 채굴 효율 2배',
 upg_up_gen9_t2: 'AI봇 특화', upg_up_gen9_t2_desc: 'AI봇 채굴 효율 2배',
 upg_up_gen9_t3: 'AI봇 마스터', upg_up_gen9_t3_desc: 'AI봇 채굴 효율 2배',
 upg_up_gen10_t1: '위성 효율화', upg_up_gen10_t1_desc: '위성 채굴 효율 2배',
 upg_up_gen10_t2: '위성 특화', upg_up_gen10_t2_desc: '위성 채굴 효율 2배',
 upg_up_gen10_t3: '위성 마스터', upg_up_gen10_t3_desc: '위성 채굴 효율 2배',
 upg_up_gen11_t1: '달기지 효율화', upg_up_gen11_t1_desc: '달기지 채굴 효율 2배',
 upg_up_gen11_t2: '달기지 특화', upg_up_gen11_t2_desc: '달기지 채굴 효율 2배',
 upg_up_gen11_t3: '달기지 마스터', upg_up_gen11_t3_desc: '달기지 채굴 효율 2배',
 upg_up_gen12_t1: '은하 효율화', upg_up_gen12_t1_desc: '은하 채굴 효율 2배',
 upg_up_gen12_t2: '은하 특화', upg_up_gen12_t2_desc: '은하 채굴 효율 2배',
 upg_up_gen12_t3: '은하 마스터', upg_up_gen12_t3_desc: '은하 채굴 효율 2배',

 // Global upgrades
 upg_up_global_click1: '강화 손가락', upg_up_global_click1_desc: '탭 파워 x2',
 upg_up_global_click2: '사이보그 손가락', upg_up_global_click2_desc: '탭 파워 x3',
 upg_up_global_cps1: '오버클럭', upg_up_global_cps1_desc: '전체 자동 수입 +50%',
 upg_up_global_cps2: '극한 오버클럭', upg_up_global_cps2_desc: '전체 자동 수입 x2',
 upg_up_global_golden1: '행운의 안테나', upg_up_global_golden1_desc: '골든 이벤트 지속시간 +50%',
 upg_up_global_golden2: '골든 자석', upg_up_global_golden2_desc: '골든 이벤트 출현 빈도 2배',
 upg_up_global_offline: '자동 채굴 최적화', upg_up_global_offline_desc: '오프라인 수익률 50% -> 75%',
 upg_up_global_combo: '콤보 지속 강화', upg_up_global_combo_desc: '콤보 유지 시간 3초 -> 5초',

 // Research upgrades
 upg_up_res_synergy: '시너지 알고리즘', upg_up_res_synergy_desc: '보유 생산기 종류당 자동 수입 +10%',
 upg_up_res_quantum: '양자 가속', upg_up_res_quantum_desc: '전체 자동 수입 x3',
 upg_up_res_ai_click: 'AI 클릭 보조', upg_up_res_ai_click_desc: '탭 파워 x5',
 upg_up_res_golden_master: '골든 마스터', upg_up_res_golden_master_desc: '골든 이벤트 효과 2배 + 지속시간 2배',
 upg_up_res_prestige_boost: '환생 촉진제', upg_up_res_prestige_boost_desc: '환생 시 블록체인 +50% 추가 획득',
 upg_up_res_combo_max: '콤보 브레이커', upg_up_res_combo_max_desc: '최대 콤보 배율 2배 -> 3배',

 // Dark Pool upgrades
 upg_up_dp_scam_promo: '스캠 코인 홍보', upg_up_dp_scam_promo_desc: '다크풀 보상 x2',
 upg_up_dp_insider_net: '인사이더 네트워크', upg_up_dp_insider_net_desc: '내부자 정보 정확도 80% -> 95%',
 upg_up_dp_chip_laundry: '고액 베팅', upg_up_dp_chip_laundry_desc: '최대 베팅 비율 25% → 50%',
 upg_up_dp_whale_ctrl: '고래 조종', upg_up_dp_whale_ctrl_desc: '8x, 12x 배율 확률 대폭 증가',

 // Prestige - Blockchain
 prestige_blockchain_title: '블록체인 환생',
 prestige_blockchain_held: '보유',
 prestige_blockchain_bonus: '보너스',
 prestige_count: '환생 횟수',
 prestige_count_unit: '회',
 prestige_gain: '환생 시',
 prestige_blockchain: '블록체인',
 prestige_execute: '환생하기',
 prestige_need: '총 생산량 1M 이상 필요',
 prestige_current: '현재',

 // Prestige - Buffs
 prestige_buff_title: '블록체인 버프',
 prestige_buff_level: 'Lv.',

 // Prestige buff names
 buff_click: '클릭 파워 증폭',
 buff_click_desc: '레벨당 탭 파워 +5%',
 buff_cps: '자동 수입 증폭',
 buff_cps_desc: '레벨당 자동 수입 +5%',
 buff_golden: '골든 확률',
 buff_golden_desc: '레벨당 골든 확률 +2%',
 buff_offline: '오프라인 효율',
 buff_offline_desc: '레벨당 오프라인 수익률 +5%',
 buff_ex_seed: '시드머니 지원',
 buff_ex_seed_desc: '환생 시 시작 시드 소폭 지급',
 buff_ex_rescue_cd: '물타기 회선',
 buff_ex_rescue_cd_desc: '물타기 긴급자금 쿨다운 소폭 감소',
 buff_ex_leak: '내부 소식통',
 buff_ex_leak_desc: '찌라시를 조금 더 일찍 수신',

 // Prestige 2 - Metaverse
 prestige2_title: '메타버스 환생',
 prestige2_coins: '메타버스 코인',
 prestige2_count: '2차 환생',
 prestige2_gain: '2차 환생 시',
 prestige2_execute: '2차 환생',
 prestige2_need: '블록체인 100개 이상 필요',
 prestige2_locked_title: '메타버스 환생',
 prestige2_locked_desc: '1차 환생 5회 + 블록체인 50개 필요',
 prestige2_locked_current: '현재',

 // Meta upgrades
 prestige2_meta_title: '메타버스 업그레이드',
 meta_auto_tap: '자동 탭봇', meta_auto_tap_desc: '1초마다 자동 탭 (탭 파워 100%)',
 meta_golden_boost: '골든 확률 증가', meta_golden_boost_desc: '골든 이벤트 출현 확률 2배',
 meta_offline_time: '오프라인 시간 연장', meta_offline_time_desc: '오프라인 보너스 8시간 -> 16시간',
 meta_milestone_boost: '마일스톤 부스트', meta_milestone_boost_desc: '마일스톤 x2 -> x3',
 meta_prestige_amplify: '환생 보너스 증폭', meta_prestige_amplify_desc: '블록체인 효과 1% -> 2%',

 // Prestige confirm
 prestige_confirm_title: '환생 확인',
 prestige_confirm_gain: '획득',
 prestige_confirm_after: '환생 후',
 prestige_confirm_warn_1: '코인, 생산기 초기화',
 prestige_confirm_keep_1: '블록체인, 업적 유지',
 prestige2_confirm_title: '2차 환생',
 prestige2_confirm_warn: '코인, 생산기, 블록체인 모두 초기화',
 prestige2_confirm_keep: '메타버스 코인, 업적 유지',

 // Achievement
 ach_title: '업적',
 ach_cat_production: '생산',
 ach_cat_generator: '생산기',
 ach_cat_prestige: '환생',
 ach_cat_click: '클릭',
 ach_cat_golden: '골든',
 ach_cat_special: '특수',

 // Achievement names (from config id)
 ach_ach_prod_1: '첫 코인', ach_ach_prod_1_desc: '코인 1 생산',
 ach_ach_prod_2: '백만장자', ach_ach_prod_2_desc: '코인 1M 생산',
 ach_ach_prod_3: '억만장자', ach_ach_prod_3_desc: '코인 1B 생산',
 ach_ach_prod_4: '조단위 부자', ach_ach_prod_4_desc: '코인 1T 생산',
 ach_ach_prod_5: '경단위 재벌', ach_ach_prod_5_desc: '코인 1Qa 생산',
 ach_ach_prod_6: '해단위 부호', ach_ach_prod_6_desc: '코인 1Qi 생산',
 ach_ach_prod_7: '자단위 거물', ach_ach_prod_7_desc: '코인 1Sx 생산',
 ach_ach_prod_8: '양단위 황제', ach_ach_prod_8_desc: '코인 1Sp 생산',
 ach_ach_prod_9: '구단위 신', ach_ach_prod_9_desc: '코인 1Oc 생산',
 ach_ach_prod_10: '간단위 초월자', ach_ach_prod_10_desc: '코인 1No 생산',
 ach_ach_prod_11: '정단위 창조주', ach_ach_prod_11_desc: '코인 1Dc 생산',
 ach_ach_prod_12: '재단위 절대자', ach_ach_prod_12_desc: '코인 1UDc 생산',
 ach_ach_gen_1: '스마트폰 마스터', ach_ach_gen_1_desc: '스마트폰 100개',
 ach_ach_gen_2: '노트북 마스터', ach_ach_gen_2_desc: '노트북 100개',
 ach_ach_gen_3: '데스크탑 마스터', ach_ach_gen_3_desc: '데스크탑 100개',
 ach_ach_gen_4: 'GPU 마스터', ach_ach_gen_4_desc: 'GPU 리그 100개',
 ach_ach_gen_5: 'ASIC 마스터', ach_ach_gen_5_desc: 'ASIC 채굴기 100개',
 ach_ach_gen_6: '농장 마스터', ach_ach_gen_6_desc: '채굴 농장 100개',
 ach_ach_gen_7: '데이터센터 마스터', ach_ach_gen_7_desc: '데이터센터 100개',
 ach_ach_gen_8: '양자컴퓨터 마스터', ach_ach_gen_8_desc: '양자컴퓨터 100개',
 ach_ach_gen_9: 'AI 마스터', ach_ach_gen_9_desc: 'AI 채굴봇 100개',
 ach_ach_gen_10: '위성 마스터', ach_ach_gen_10_desc: '위성 채굴기 100개',
 ach_ach_gen_11: '달 마스터', ach_ach_gen_11_desc: '달 채굴 기지 100개',
 ach_ach_gen_12: '은하 마스터', ach_ach_gen_12_desc: '은하 채굴 네트워크 100개',
 ach_ach_pres_1: '첫 환생', ach_ach_pres_1_desc: '1차 환생 1회',
 ach_ach_pres_2: '환생 마스터', ach_ach_pres_2_desc: '1차 환생 10회',
 ach_ach_pres_3: '환생 전설', ach_ach_pres_3_desc: '1차 환생 50회',
 ach_ach_pres_4: '블록체인 수집가', ach_ach_pres_4_desc: '블록체인 100개 보유',
 ach_ach_pres_5: '메타버스 입성', ach_ach_pres_5_desc: '2차 환생 1회',
 ach_ach_pres_6: '메타버스 거물', ach_ach_pres_6_desc: '2차 환생 5회',
 ach_ach_pres_7: '블록체인 제왕', ach_ach_pres_7_desc: '블록체인 500개 보유',
 ach_ach_pres_8: '환생 신', ach_ach_pres_8_desc: '1차 환생 100회',
 ach_ach_click_1: '클릭 초보', ach_ach_click_1_desc: '탭 100회',
 ach_ach_click_2: '클릭 마니아', ach_ach_click_2_desc: '탭 1,000회',
 ach_ach_click_3: '클릭 광', ach_ach_click_3_desc: '탭 10,000회',
 ach_ach_click_4: '클릭 신', ach_ach_click_4_desc: '탭 100,000회',
 ach_ach_click_5: '손목 파괴자', ach_ach_click_5_desc: '콤보 50 달성',
 ach_ach_click_6: '초당 10탭 달인', ach_ach_click_6_desc: '콤보 100 달성',
 ach_ach_golden_1: '골든 헌터', ach_ach_golden_1_desc: '골든 이벤트 10회 클릭',
 ach_ach_golden_2: '골든 마스터', ach_ach_golden_2_desc: '골든 이벤트 50회 클릭',
 ach_ach_golden_3: '골든 레전드', ach_ach_golden_3_desc: '골든 이벤트 200회 클릭',
 ach_ach_golden_4: '행운의 손', ach_ach_golden_4_desc: '럭키 골든 5회 획득',
 ach_ach_spec_1: '광고 후원자', ach_ach_spec_1_desc: '보상형 광고 10회 시청',
 ach_ach_spec_2: '광고 VIP', ach_ach_spec_2_desc: '보상형 광고 100회 시청',
 ach_ach_spec_3: '오프라인 부자', ach_ach_spec_3_desc: '오프라인 보너스 수령 10회',
 ach_ach_spec_4: '출석왕', ach_ach_spec_4_desc: '7일 연속 출석',
 ach_ach_spec_5: '완벽주의자', ach_ach_spec_5_desc: '모든 생산기 100개씩 보유',
 ach_ach_spec_6: '클릭 마스터', ach_ach_spec_6_desc: '코인 클릭 1,000회',
 ach_ach_spec_7: '속도광', ach_ach_spec_7_desc: '환생 없이 1시간 내 1B 생산',
 ach_ach_spec_8: '완주자', ach_ach_spec_8_desc: '모든 업적 달성',

 // Achievement reward types
 ach_reward_cps: '+{v}% 자동 수입',
 ach_reward_click: '+{v}% 탭',
 ach_reward_prestige: '환생',

 // Golden events
 golden_golden_coin: '골든 코인', golden_golden_coin_desc: '자동 수입 x777을 즉시 획득',
 golden_lucky_golden: '럭키 골든', golden_lucky_golden_desc: '15초간 자동 수입 x7',
 golden_click_frenzy: '클릭 프렌지', golden_click_frenzy_desc: '30초간 탭 파워 x10',
 golden_production_boost: '생산 부스트', golden_production_boost_desc: '30초간 모든 생산 x5',
 golden_mega_jackpot: '메가 잭팟', golden_mega_jackpot_desc: '현재 코인 x10',

 // Settings
 settings_title: '설정',
 settings_sound: '사운드',
 settings_bgm: 'BGM',
 settings_sfx: 'SFX',
 settings_language: '언어',
 settings_stats_title: '통계',
 settings_total_earned: '총 생산량',
 settings_total_taps: '총 탭',
 settings_max_combo: '최대 콤보',
 settings_golden_clicks: '골든 클릭',
 settings_prestige_count: '환생',
 settings_prestige2_count: '2차 환생',
 settings_play_time: '플레이 시간',
 settings_data_title: '데이터',
 settings_save: '수동 저장',
 settings_saved: '저장 완료!',
 settings_reset: '데이터 초기화',
 settings_reset_confirm: '정말 모든 데이터를 초기화하시겠습니까?',

 // Offline
 offline_title: '오프라인 보너스',
 offline_duration: '동안 채굴',
 offline_capped: '(최대치)',
 offline_claim: '수령하기',
 offline_ad_double: '광고 2배',

 // Common
 confirm: '확인',
 cancel: '취소',

 // Ad rewards
 ad_cps_boost: '자동 수입 30초 부스트',
 ad_offline_double: '오프라인 보너스 2배',
 ad_prestige_bonus: '환생 보너스 +50%',
 ad_timeskip: '2시간 타임스킵',
 ad_free_docs: '무료 문서',
 ad_golden_double: '골든 효과 2배',
 ad_start_boost: '시작 부스트 60초',
 ad_income_x5: '수입 10배',
 ad_tap_x10: '탭 파워 10배',
 ad_income_x5_desc: '15초간 수입 10배',
 ad_timeskip_desc: '2시간 즉시 생산',
 ad_tap_x10_desc: '15초간 탭 10배',
 ad_popup_income_title: '수입 x10 부스트',
 ad_popup_income_desc: '광고를 시청하면 15초간 모든 수입이 10배가 됩니다!',
 ad_popup_timeskip_title: '2시간 타임스킵',
 ad_popup_timeskip_desc: '광고를 시청하면 2시간 분량의 코인을 즉시 획득합니다!',
 ad_popup_tap_title: '탭 파워 x10',
 ad_popup_tap_desc: '광고를 시청하면 15초간 탭 파워가 10배가 됩니다!',
 ad_popup_watch: '시청하기',
 ad_popup_cancel: '닫기',

 // Achievement toast
 ach_toast: '달성!',

 // Missing keys (fix i18n key mismatches)
 action_daily: '일일보너스',
 gen_locked: '잠김',
 prestige_blockchain_owned: '보유 블록체인',
 prestige_reward_prefix: '환생 시 ',
 prestige_blockchain_unit: '블록체인',
 prestige_btn: '환생하기',
 prestige_need_1m: '총 생산량 4M 이상 필요',
 prestige_confirm_warn: '코인, 생산기 초기화',
 prestige_confirm_keep: '블록체인, 업적 유지',
 btn_cancel: '취소',
 prestige2_meta_coins: '메타버스 코인',
 prestige2_reward_prefix: '2차 환생 시 ',
 prestige2_meta_unit: '메타버스 코인',
 prestige2_btn: '2차 환생',
 prestige2_need_100: '블록체인 100개 이상 필요',
 prestige2_confirm_gain: '획득',
 prestige2_upgrades_title: '메타버스 업그레이드',
 ach_reward_tap: '탭',
 ach_reward_golden: '골든',
 ach_unlocked: '달성!',
 settings_stats: '통계',
 stats_total_earned: '총 생산량',
 stats_total_clicks: '총 탭',
 stats_max_combo: '최대 콤보',
 stats_golden_clicks: '골든 클릭',
 stats_prestige_count: '환생',
 stats_prestige2_count: '2차 환생',
 stats_play_time: '플레이 시간',
 settings_data: '데이터',
 toast_saved: '저장 완료!',
 settings_reset_title: '데이터 초기화',

 // Market sentiment
 market_price: '시세',
 manip_sns_hype: 'SNS 선동',
 manip_sns_hype_desc: '시세 상승 유도 (30% 역효과)',
 manip_influencer: '인플루언서',
 manip_influencer_desc: '안정적 시세 상승',
 manip_pump_dump: '펌프&덤프',
 manip_pump_dump_desc: '급등 후 폭락',

 // Dark Pool
 tab_darkpool: '다크풀',
 dp_title: 'Dark Pool',
 dp_total_bets: '총 베팅',
 dp_banner_soon: '다크풀 시작',
 dp_banner_live: '다크풀 진행 중!',
 dp_skip_cooldown: '광고 보고 바로 시작',
 dp_wins: '승리',
 dp_profit: '순수익',
 dp_next_round: '다음 라운드까지',
 dp_bet_hint: '보유 코인의 일부를 베팅하세요',
 dp_bet_coins: '코인 베팅',
 dp_available: '보유',
 dp_win_preview: '예상 보상',
 dp_real_coins: '코인',
 dp_tutorial_title: 'Dark Pool 안내',
 dp_tutorial_1: 'Dark Pool은 보유 코인으로 경매에 참여하는 미니게임입니다.',
 dp_tutorial_2: '3개 코인 중 펌핑될 코인을 맞추면 베팅금 \u00D7 배율만큼 보상!',
 dp_tutorial_3: '코인의 1%~25%를 베팅할 수 있습니다. (업그레이드로 50%까지)',
 dp_tutorial_4: '광고를 보면 내부자 정보를 얻을 수 있습니다. (80% 정확도)',
 dp_betting: '베팅 진행중',
 dp_your_bet: '내 베팅',
 dp_get_insider: '내부자 정보',
 dp_place_bet: '베팅하기',
 dp_bet_placed: '베팅 완료',
 dp_waiting_result: '결과를 기다리는 중...',
 dp_revealing: '결과 공개중',
 dp_result: '결과',
 dp_you_won: '당첨!',
 dp_you_lost: '탈락...',
 dp_claim: '수령하기',
 dp_no_bet: '이번 라운드는 패스',
 dp_was_winner: '당첨!',
 dp_insider_title: '내부자 정보',
 dp_insider_hint: '가 오를 확률 80%! 예상',
 dp_insider_warn: '* 정보가 100% 정확하지 않을 수 있음',
 dp_insider_received: '내부자 정보를 획득했습니다!',

 // Onboarding
 onboarding_tap: '탭해서 코인을 채굴하세요!',
 onboarding_buy: '코인으로 생산기를 구매하세요!',
 ob_step0: '코인을 탭해서 채굴하자!',
 ob_step1: '번 코인으로 거래소에서 진짜 투자를 해보자',
 ob_step2: '이 코인을 한번 사보자',
 ob_step3: '오르고 있어! 지금 팔면 대박!',
 ob_step4: '채굴로 번 걸 거래소에서 몇 배로! 이게 이 게임의 핵심이야',
 ob_skip: '건너뛰기',

 // Golden event modal
 golden_event: '골든 이벤트',
 golden_claim_normal: '수령',
 golden_claim_ad: '광고x2',

 // Prestige ad
 prestige_ad_bonus: '광고+100%',

 // Ad boost
 golden_ad_income_x5: 'x10 부스트',

 // Exchange
 exchange_title: '코인 거래소',
 exchange_buy: '매수',
 exchange_sell: '매도',
 exchange_holdings: '보유',
 exchange_avg_price: '평단',
 exchange_profit: '수익',
 exchange_unlock: '해금',
 exchange_locked: '잠김',
 exchange_news: '뉴스',
 exchange_24h: '변동',

 // News events
 news_celeb_tweet: '유명 인플루언서가 PIKA를 언급!',
 news_hack: '대형 거래소 해킹 발생!',
 news_nova_update: 'NOVA 네트워크 대규모 업데이트!',
 news_whale_buy: '고래가 대량 매수!',
 news_regulation: '️ 규제 강화 뉴스!',
 news_frog_burn: 'FROG 대량 소각 이벤트!',
 news_bolt_partner: 'BOLT 대기업 파트너십 체결!',
 news_star_listing: 'STAR 대형 거래소 상장!',
 news_bull_market: '강세장 시작 신호!',
 news_bear_market: '약세장 경고!',

 // === 거래소 (v2.0) ===
 tab_exchange: '거래소',
 coin_stonecoin: '스톤코인',
 ex_my_holdings: '내 투자',
 ex_invested: '투자원금',
 ex_valuation: '평가금액',
 ex_eval_pnl: '평가손익',
 ex_all_coins: '전체 코인',
 coin_nebula: '네뷸라',
 coin_chickencoin: '치킨코인',
 coin_moonfrog: '문프로그',
 coin_pumpking: '펌프킹',
 coin_lattice: '래티스',
 coin_moonshot: '문샷',
 coin_pizzaswap: '피자스왑',
 coin_catchain: '캣체인',
 coin_rocksolid: '록솔리드',
 coin_yolocoin: '욜로코인',
 coin_ramenfi: '라멘파이',
 coin_ghostnet: '고스트넷',
 coin_crabdao: '크랩다오',
 coin_tacotoken: '타코토큰',
 coin_sockswap: '삭스왑',
 coin_ufomoney: '유포머니',
 coin_doomfloor: '둠플로어',
 coin_lambodream: '람보드림',
 coin_diamondpaw: '다이아손',
 coin_rugbeater: '러그비터',
 coin_sushirocket: '스시로켓',
 coin_nyanfi: '냥파이',
 coin_gigachad: '기가차드',
 coin_kimchibase: '김치베이스',
 coin_popcat: '팝캣',
 coin_baguettefi: '바게트파이',
 coin_vaporwave: '베이퍼웨이브',
 coin_brrrcoin: '브르코인',
 coin_panicsell: '패닉셀',
 coin_wenmoon: '웬문',
 ex_delisted_badge: '상폐',
 ex_revived_badge: '부활',
 cnews_list_new: '{coin} 거래소 신규 상장 - 초기 진입 열기',
 cnews_list_delist: '{coin} 거래량 미달로 상장폐지 - 보유분 자동 청산',
 cnews_list_revive: '{coin} 돌아왔다 - 리브랜딩 후 재상장',
 ex_title: '거래소',
 ex_total_assets: '총자산',
 ex_cash: '보유 코인',
 ex_total_pnl: '총수익률',
 ex_holding_badge: '보유',
 ex_back: '뒤로',
 ex_no_holding: '아직 보유하지 않은 코인입니다',
 ex_amount: '수량',
 ex_avg_price: '평단가',
 ex_value: '평가금액',
 ex_pnl: '수익률',
 ex_buy: '매수',
 ex_sell: '매도',
 ex_max: '최대',
 ex_spend: '매수 금액',
 ex_sell_amount: '매도 수량',
 ex_buy_success: '매수 체결!',
 ex_sell_success: '매도 체결!',
 ex_insufficient_funds: '코인이 부족합니다',
 ex_insufficient_holding: '보유 수량이 부족합니다',

 // === 정보 경제: 뉴스 피드 + 찌라시 (Sprint 2a) ===
 news_feed_title: '속보',
 news_section_title: '시장 소식',
 news_ticker_empty: '아직 새로운 소식이 없습니다',
 news_now: '방금',
 news_leak_tag: '찌라시',
 leak_verdict_true: '적중',
 leak_verdict_fake: '불발',
 factcheck_btn: '팩트체크',
 factcheck_sub: '광고 보고 진위 확인',
 factcheck_true: '진짜 정보',
 factcheck_fake: '가짜 찌라시',
 leak_confirmed_target: '확인된 타겟',
 leak_up_1: '{coin}에 큰 손 움직임 포착?',
 leak_up_2: '{coin} 곧 대형 호재 터진다는 소문',
 leak_up_3: '{coin} 내부자들이 조용히 담는 중이라던데',
 leak_down_1: '{coin} 대량 매도 물량 준비 중?',
 leak_down_2: '{coin} 안 좋은 소식 나온다는 얘기가...',
 leak_down_3: '{coin} 큰 손들 빠져나가는 정황 포착',

 // 코인 타겟 뉴스 템플릿
 cnews_listing: '{coin}, 해외 대형 거래소 상장 확정',
 cnews_celebrity: '유명 셀럽 "{coin} 보유 중" 발언',
 cnews_partnership: '{coin} 재단, 대기업과 파트너십 체결',
 cnews_burn: '{coin} 대규모 소각 이벤트 발표',
 cnews_upgrade: '{coin} 네트워크 업그레이드 성공',
 cnews_etf: '{coin} ETF 승인 임박 보도',
 cnews_payment: '대형 쇼핑몰, {coin} 결제 도입',
 cnews_viral: '{coin} 밈, SNS에서 폭발적 확산',
 cnews_airdrop: '{coin} 보유자 대상 에어드랍 발표',
 cnews_buyback: '{coin} 재단, 자체 물량 바이백 개시',
 cnews_influencer_news: '100만 구독 유튜버, {coin} 집중 분석',
 cnews_patent: '{coin} 개발사, 핵심 기술 특허 출원',
 cnews_devs_missing: '{coin} 개발팀 연락 두절설 확산',
 cnews_hack: '{coin} 지갑 해킹 정황 포착',
 cnews_regulation: '금융당국, {coin} 규제 검토 착수',
 cnews_delisting: '일부 거래소, {coin} 상장폐지 검토설',
 cnews_whale_sell: '{coin} 대형 지갑에서 대량 매도 감지',
 cnews_lawsuit: '{coin} 재단 상대 집단 소송 제기',
 cnews_bug: '{coin} 스마트컨트랙트 버그 발견',
 cnews_founder_sell: '{coin} 창립자, 보유 물량 매도 정황',
 cnews_fud: '유명 애널리스트 "{coin}은 끝났다" 혹평',
 cnews_outage: '{coin} 네트워크 일시 중단 발생',
 cnews_stone_difficulty: '{coin} 채굴 난이도 사상 최고, 채굴자 이탈 조짐',
 cnews_stone_museum: '국립박물관, {coin} 제네시스 블록 전시 결정',
 cnews_nebula_launch: '{coin} 위성 노드 발사 성공',
 cnews_nebula_debris: '{coin} 노드 위성, 우주 쓰레기와 충돌 위기',
 cnews_chicken_payment: '전국 치킨 프랜차이즈, {coin} 결제 도입',
 cnews_chicken_flu: '조류독감 확산에 {coin} 커뮤니티 패닉',
 cnews_frog_moon: '{coin} 커뮤니티 "달까지 간다" 밈 폭발',
 cnews_frog_pond: '{coin} 고래 "연못으로 돌아간다" 전량 매도',
 cnews_pump_festival: '{coin} 호박 축제 개최, 신규 지갑 급증',
 cnews_pump_probe: '{coin} 시세조종 의혹 조사 착수',

 // 코인 상세: 선동 + 광고 훅 (Sprint 2a)
 cd_manip_title: '선동',
 cd_manip_active: '선동 진행 중',
 cd_manip_backfire: '역효과',
 cd_manip_success: '선동 시작!',
 ex_manip_badge: '선동',
 whale_phase_label: '세력 동향',
 whale_phase_dormant: '잠잠함',
 whale_phase_accumulating: '세력 매집 중',
 whale_phase_pumping: '펌핑 임박',
 whale_phase_dumping: '덤핑 위험',
 whale_tracker_btn: '고래 지갑 추적기',
 whale_tracker_sub: '광고 보고 세력 단계 확인',
 rescue_btn: '물타기 긴급자금',
 rescue_sub: '광고 보고 자금 수령',
 rescue_cooldown: '쿨다운',
 rescue_received: '긴급자금 입금 완료!',
 ad_fact_check: '팩트체크',
 ad_whale_tracker: '고래 추적기',
 ad_rescue_funds: '긴급자금',

 // === Volatility engine + rug pull (Sprint 2b) ===
 ex_rug_badge: '러그풀',
 cnews_rug_alert: '긴급: {coin} 개발진 지갑에서 대량 물량 이동 포착',

 // Loss-aversion ad hooks (Sprint 2b)
 panic_btn: '긴급 탈출',
 panic_sub: '광고 보고 폭락 직전 가격에 50% 매도',
 panic_success: '긴급 탈출 체결!',
 insurance_btn: '러그풀 보험',
 insurance_sub: '광고 보고 30분간 보험 활성화',
 insurance_active: '보험 적용 중',
 insurance_payout: '보험금 지급',
 rewind_btn: '시간 되감기',
 rewind_sub: '광고 보고 직전 거래 1건 취소',
 rewind_success: '직전 거래가 취소되었습니다',
 ad_panic_sell: '긴급 탈출',
 ad_rug_insurance: '러그풀 보험',
 ad_trade_rewind: '시간 되감기',

 // Dark pool x exchange link (Sprint 2b)
 cnews_dp_pump: '다크풀에서 예열된 {coin}, 거래소에서도 급등 조짐',

 // === 가상 기업 (Sprint 3a) ===
 co_voltmotors: '볼트모터스', co_moonbase: '문베이스', co_hashworks: '해시웍스', co_moonlightent: '달빛엔터', co_goldenfry: '골든프라이', co_pumpcapital: '펌프캐피탈',
 cnews_co_volt_payment: '{company}, 전기차 {coin} 결제 도입 발표',
 cnews_co_volt_recall: '{company} 주력 전기차 대량 리콜, {coin} 투심 냉각',
 cnews_co_moonbase_listing: '{company}, {coin} 메인 마켓 승격',
 cnews_co_moonbase_outage: '{company} 서버 마비, {coin} 거래 일시 중단',
 cnews_co_hash_rig: '{company} 신형 채굴기 공개, {coin} 해시레이트 급등',
 cnews_co_hash_shock: '{company} 실적 어닝쇼크, {coin} 채굴 축소 우려',
 cnews_co_mle_idol: '{company} 아이돌, {coin} 밈 챌린지 시작',
 cnews_co_mle_scandal: '{company} 소속 스타 스캔들, {coin} 밈 화력 급랭',
 cnews_co_gfry_event: '{company}, {coin} 결제 시 치킨 반값 이벤트',
 cnews_co_gfry_ceo: '{company} CEO 구속, {coin} 커뮤니티 충격',
 cnews_co_pcap_buy: '{company} CEO, {coin} 대량 매입 트윗',
 cnews_co_pcap_probe: '{company} 압수수색, {coin} 세력 자금 의혹',

 // === 뉴스 댓글창 (Sprint 3a) ===
 ncm_title: '댓글', ncm_you: '나', ncm_your_take: '내 생각은?', ncm_open_hint: '댓글 보기',
 stance_moon: '가즈아', stance_cut: '손절각', stance_watch: '관망', stance_rekt: '나만 물렸냐',
 // 호재 댓글 풀 (cmt_up) - 60종
 cmt_up_1: '존버는 승리한다', cmt_up_2: '지금이 저점이다 사라', cmt_up_3: '이거 곧 떡상각', cmt_up_4: '풀매수 갑니다',
 cmt_up_5: '드디어 물린 거 탈출각', cmt_up_6: '세력 붙었다 가즈아', cmt_up_7: '차트가 우상향이네', cmt_up_8: '이번엔 진짜 간다',
 cmt_up_9: '불장 시작이다', cmt_up_10: '지금 안 사면 후회함', cmt_up_11: '거래량 터졌다', cmt_up_12: '손절한 놈들 눈물',
 cmt_up_13: '내 평단 회복 가즈아', cmt_up_14: '이게 바로 떡상이지', cmt_up_15: '홀더는 웃는다', cmt_up_16: '추매 각이다',
 cmt_up_17: '고래가 매집 중', cmt_up_18: '이 소식이면 2배는 간다', cmt_up_19: '드디어 반등이다', cmt_up_20: '존버 3년차 웃는다',
 cmt_up_21: '지금 안타면 벼락거지', cmt_up_22: '떡상 가즈아', cmt_up_23: '나만 없어 코인', cmt_up_24: '익절은 예술이다',
 cmt_up_25: '세력님 저 여기 있어요', cmt_up_26: '이거 내 시드 다 넣었다 형들', cmt_up_27: '지금이 저점이다(3일째)', cmt_up_28: '감자밭 일구러 왔다',
 cmt_up_29: '밈코인은 감성으로 사는거임', cmt_up_30: '이 방 또 설레발이지만 나도 탐', cmt_up_31: '골든크로스 떴다', cmt_up_32: '개미들 다 태워라',
 cmt_up_33: '슈팅 나온다 잡아', cmt_up_34: '이건 무조건 간다에 한표', cmt_up_35: '눌림목에서 담았다', cmt_up_36: '저점 매수 성공',
 cmt_up_37: '오늘 라면 대신 소고기', cmt_up_38: '드디어 초록불이다', cmt_up_39: '내 예언 적중', cmt_up_40: '손절 안 하길 잘했다',
 cmt_up_41: '거래량 실린다 진짜다', cmt_up_42: '이 코인 리브랜딩 성공각', cmt_up_43: '고점 갱신 가즈아', cmt_up_44: '분할 매수 다 채웠다',
 cmt_up_45: '이번엔 느낌이 다르다', cmt_up_46: '차트가 이쁘게 그려진다', cmt_up_47: '물린 거 본전 왔다', cmt_up_48: '지지선 반등 확인',
 cmt_up_49: '세력 매집 흔적 보인다', cmt_up_50: '가즈아를 외쳐라', cmt_up_51: '이거 다음 텐배거', cmt_up_52: '지금 타면 막차 아님',
 cmt_up_53: '개미의 승리다', cmt_up_54: '평단 밑에서 주웠다', cmt_up_55: '내일 아침이 기대된다', cmt_up_56: '홀더 인증합니다',
 cmt_up_57: '이 방 믿고 풀매수', cmt_up_58: '반등 각 나왔다', cmt_up_59: '존버 끝판왕 여기 있다', cmt_up_60: '오늘도 우상향 감사합니다',
 cmt_up_61: '이 방 사람들 왜 이렇게 확신하냐', cmt_up_62: '시드 절반만 넣을걸 아쉽다', cmt_up_63: '물타기가 신의 한 수였다', cmt_up_64: '떨어질 때마다 줍줍했더니 웃는다',
 cmt_up_65: '존버는 배신하지 않는다', cmt_up_66: '이 코인 볼매다 계속 담는다', cmt_up_67: '빨간불 보니 마음이 편하네', cmt_up_68: '고래 지갑 움직였다는데 진짜냐',
 cmt_up_69: '라면 국물에 눈물 안 넣게 됐다', cmt_up_70: '이번 상승은 근거가 있다', cmt_up_71: '손절한 놈 지금 배 아프겠네', cmt_up_72: '차트가 드디어 말을 듣는다',
 cmt_up_73: '코인은 결국 멘탈싸움이다', cmt_up_74: '익절 타이밍만 잘 잡으면 된다', cmt_up_75: '이 방 분위기 오랜만에 따뜻하네', cmt_up_76: '물린 거 본전 오면 바로 나간다',
 cmt_up_77: '지금 안 사면 또 후회할 각', cmt_up_78: '세력이 밀어주는 게 느껴진다', cmt_up_79: '오늘은 계좌 보는 게 즐겁다', cmt_up_80: '존버 3년차 드디어 빛 본다',
 cmt_up_81: '이거 안 사면 벼락거지 된다', cmt_up_82: '차트가 심장을 뛰게 하네', cmt_up_83: '손가락이 먼저 매수를 눌렀다', cmt_up_84: '치킨값은 벌었다 오늘',
 cmt_up_85: '감자농사보다 낫다 이건', cmt_up_86: '코인은 우상향 오늘만큼은 진짜', cmt_up_87: '리딩방 믿은 게 신의 한 수', cmt_up_88: '떡상 가즈아 심장 터진다',
 cmt_up_89: '존버 3년차 아직 안 죽었다', cmt_up_90: '나만 안 물렸네 이번엔', cmt_up_91: '익절은 예술 손절은 기술', cmt_up_92: '물타기가 익사 대신 구조가 됐다',
 cmt_up_93: '세력 설거지 전에 탈출 성공', cmt_up_94: '이 방 오랜만에 웃음꽃 폈다', cmt_up_95: '내 계좌만 우하향인 줄 알았는데', cmt_up_96: '드디어 라면 졸업이다',
 cmt_up_97: '반등각 잡은 나 칭찬해', cmt_up_98: '고점 물린 거 드디어 본전각', cmt_up_99: '이거 텐배거 예약이다', cmt_up_100: '오늘은 계좌가 효자다',
 // 악재 댓글 풀 (cmt_down) - 60종
 cmt_down_1: '이거 세력 장난이다', cmt_down_2: '손절각 나왔네', cmt_down_3: '또 물렸다 나만', cmt_down_4: '탈출하라 지금',
 cmt_down_5: '이래서 코인 하면 안 됨', cmt_down_6: '이거 러그풀 냄새', cmt_down_7: '고점에 물린 사람 손', cmt_down_8: '패닉셀 시작',
 cmt_down_9: '내 원금 어디감', cmt_down_10: '차트 박살났네', cmt_down_11: '이 코인 끝났다', cmt_down_12: '세력 덤핑 시작',
 cmt_down_13: '지금이라도 던져라', cmt_down_14: '눈물 흘리며 손절', cmt_down_15: '이게 나라냐', cmt_down_16: '아 팔걸 진작',
 cmt_down_17: '반등 없다 도망가', cmt_down_18: '홀더들 오늘도 지옥', cmt_down_19: '개미만 죽어난다', cmt_down_20: '이 소식이면 반토막각',
 cmt_down_21: '차트가 심전도냐', cmt_down_22: '이거 상장폐지각인데', cmt_down_23: '손절하니까 오르네 국룰', cmt_down_24: '라면이나 끓이러 간다',
 cmt_down_25: '개미 무빙 보소', cmt_down_26: '물렸는데 존버 각인가요', cmt_down_27: '세력 또 개미털기', cmt_down_28: '탈출은 지능순임',
 cmt_down_29: '이 방 또 물타기 유도', cmt_down_30: '내 시드 순삭됐다', cmt_down_31: '데드캣 조심해라', cmt_down_32: '지지선 뚫렸다',
 cmt_down_33: '멘탈 나갔다 진짜', cmt_down_34: '오늘도 파란불 파티', cmt_down_35: '이거 먹튀 준비 중', cmt_down_36: '개미 등골 빼먹네',
 cmt_down_37: '반토막 인증합니다', cmt_down_38: '존버하다 순삭', cmt_down_39: '이평선 다 깨졌다', cmt_down_40: '세력 이탈 신호다',
 cmt_down_41: '지금 던지는 게 이득', cmt_down_42: '희망회로 그만 돌려라', cmt_down_43: '이 코인 답 없다', cmt_down_44: '고점 대비 -80%',
 cmt_down_45: '물타기하다 다 잃었다', cmt_down_46: '차트가 계단식 하락', cmt_down_47: '오늘도 눈물의 라면', cmt_down_48: '이래서 코인은 도박',
 cmt_down_49: '개미 지옥 오픈했네', cmt_down_50: '설레발이 이럴 줄 알았다', cmt_down_51: '손절이 답이다', cmt_down_52: '세력만 웃는다',
 cmt_down_53: '내 계좌 녹는다', cmt_down_54: '이건 못 버틴다', cmt_down_55: '반등 기다리다 늙는다', cmt_down_56: '결국 개미가 총알받이',
 cmt_down_57: '이 방 콜 반대로 가면 됨', cmt_down_58: '손절 버튼이 안 눌린다', cmt_down_59: '희망은 사치였다', cmt_down_60: '오늘도 계좌 초토화',
 cmt_down_61: '이 방 또 선동이네 조심해라', cmt_down_62: '내 시드가 녹고 있어 실화냐', cmt_down_63: '물타기가 답이라더니 더 물렸다', cmt_down_64: '나만 고점에 물렸나 진짜',
 cmt_down_65: '희망회로 그만 돌리자 우리', cmt_down_66: '이 코인 상장폐지각 아니냐', cmt_down_67: '라면 대신 물이나 마셔야겠다', cmt_down_68: '손절 못 하고 존버하다 이 꼴',
 cmt_down_69: '고래가 다 던지고 나갔다는데', cmt_down_70: '이번 하락은 근거가 없어 무섭다', cmt_down_71: '익절한 사람만 이겼네 늘 그렇지', cmt_down_72: '차트가 지하실 파러 간다',
 cmt_down_73: '코인은 멘탈싸움이라더니 나가떨어짐', cmt_down_74: '손절 타이밍 놓친 게 크다', cmt_down_75: '이 방 분위기 초상집 됐다', cmt_down_76: '본전은 이번 생에 못 볼 듯',
 cmt_down_77: '지금이라도 던지는 게 이득인가', cmt_down_78: '세력이 개미 다 털고 나갔다', cmt_down_79: '오늘도 계좌 보기가 무섭다', cmt_down_80: '존버 3년차 아직도 마이너스',
 cmt_down_81: '차트가 심전도냐 삐 소리 나겠다', cmt_down_82: '치킨값 벌려다 치킨집 넘겼다', cmt_down_83: '이 방 또 설거지 시작이네', cmt_down_84: '리딩방 믿은 내가 바보지',
 cmt_down_85: '손가락이 매수를 눌러버렸다', cmt_down_86: '물타기하다 그냥 익사했다', cmt_down_87: '나만 물렸지 나만 물렸구나', cmt_down_88: '감자농사가 나았을 각',
 cmt_down_89: '코인은 우상향 내 계좌만 우하향', cmt_down_90: '지금이 저점이다 3일째 외치는 중', cmt_down_91: '존버각 vs 손절각 정답은 이미 늦음', cmt_down_92: '세력 설거지에 그릇째 들어갔다',
 cmt_down_93: '내 시드 어디갔나요 진심', cmt_down_94: '탈출은 지능순이라더니 나는 아니었다', cmt_down_95: '반등 기다리다 머리 셌다', cmt_down_96: '이 방 콜 반대로 갔어야 했다',
 cmt_down_97: '손절 버튼이 물리적으로 안 눌린다', cmt_down_98: '오늘도 라면 국물이 짜다', cmt_down_99: '희망회로 연기 난다 이제', cmt_down_100: '벼락거지 코스 정상 진행 중',
 // NPC 일반 응답 풀 (npc_reply)
 npc_reply_1: '형 말이 맞네', npc_reply_2: '그건 좀 아닌 듯', npc_reply_3: '나도 그렇게 봄', npc_reply_4: '너만 그런 거 아님',
 npc_reply_5: '차트나 봐라', npc_reply_6: '이미 늦었다', npc_reply_7: '기다려보자', npc_reply_8: '결국 세력이 이김',
 npc_reply_9: '형 말대로 될지 지켜보자', npc_reply_10: '이번엔 좀 다른 것 같기도', npc_reply_11: '나도 반쯤은 동의한다', npc_reply_12: '결국 세력 손바닥 안이지',
 npc_reply_13: '물타기는 신중하게 해라', npc_reply_14: '고래 움직임부터 봐야지', npc_reply_15: '손절선 지키는 게 실력이다', npc_reply_16: '확신할 땐 오히려 조심해라',
 // NPC 응답 - 강세 스탠스에 반응 (bull)
 npc_reply_bull_1: '가즈아 형님만 믿는다', npc_reply_bull_2: '나도 풀매수했다', npc_reply_bull_3: '이번엔 진짜 가나', npc_reply_bull_4: '설레발은 금물인데',
 npc_reply_bull_5: '형만 믿고 풀매수 간다', npc_reply_bull_6: '이번엔 근거가 있어 보인다', npc_reply_bull_7: '나도 떨어질 때 줍줍했다', npc_reply_bull_8: '세력 붙었으면 게임 끝이지',
 npc_reply_bull_9: '존버 각 잡았다 나도', npc_reply_bull_10: '물타기로 평단 낮췄다', npc_reply_bull_11: '빨간불이라 더 담았다', npc_reply_bull_12: '이 방 오랜만에 확신 든다',
 npc_reply_bull_13: '익절 타이밍만 잘 잡자', npc_reply_bull_14: '고래 매집이면 진짜다', npc_reply_bull_15: '소고기 먹을 준비 하자', npc_reply_bull_16: '가즈아 이번엔 느낌 좋다',
 npc_reply_bull_17: '이번엔 나도 확신 든다', npc_reply_bull_18: '떨어지면 더 담을 준비 됐다', npc_reply_bull_19: '존버 각인데 같이 가자', npc_reply_bull_20: '세력 붙었으면 무조건이지',
 npc_reply_bull_21: '평단 낮춰놨으니 느긋하다', npc_reply_bull_22: '이 방 오랜만에 각 나온다', npc_reply_bull_23: '손 떨지 말고 존버하자', npc_reply_bull_24: '반등 오면 소고기 쏜다',
 // NPC 응답 - 약세 스탠스에 반응 (bear)
 npc_reply_bear_1: '손절이 답이었나', npc_reply_bear_2: '나만 물린 거 아니었네', npc_reply_bear_3: '겁쟁이는 손절부터', npc_reply_bear_4: '아직 버틴다 나는',
 npc_reply_bear_5: '손절이 답이었나 보다', npc_reply_bear_6: '물타기하다 나도 더 물렸다', npc_reply_bear_7: '고점에 물린 게 나만 아니었네', npc_reply_bear_8: '시드 녹는 소리 들린다',
 npc_reply_bear_9: '희망회로 그만 돌려야겠다', npc_reply_bear_10: '익절한 사람만 이겼네', npc_reply_bear_11: '본전은 물 건너간 듯', npc_reply_bear_12: '라면 각이다 오늘도',
 npc_reply_bear_13: '세력이 다 털고 나갔다', npc_reply_bear_14: '지하실 파는 차트 무섭다', npc_reply_bear_15: '멘탈싸움에서 졌다 인정', npc_reply_bear_16: '손절 버튼이 안 눌린다',
 npc_reply_bear_17: '손절이 정답이었나 보다', npc_reply_bear_18: '나도 반은 던졌다', npc_reply_bear_19: '지하실 더 있다 조심해라', npc_reply_bear_20: '희망회로 이제 접는다',
 npc_reply_bear_21: '멘탈 나가서 계좌 안 본다', npc_reply_bear_22: '물타기는 진짜 독이더라', npc_reply_bear_23: '익절한 형들이 부럽다', npc_reply_bear_24: '오늘도 라면으로 버틴다',
 // NPC 응답 - 중립 스탠스에 반응 (neut)
 npc_reply_neut_1: '관망도 실력이다', npc_reply_neut_2: '지켜보는 게 상책', npc_reply_neut_3: '결정 못 하면 지는 거임', npc_reply_neut_4: '나도 일단 대기',
 npc_reply_neut_5: '확신 들 때까지 관망한다', npc_reply_neut_6: '근거 없는 확신은 위험하다', npc_reply_neut_7: '물타기는 추세 보고 하자', npc_reply_neut_8: '고래 움직임부터 확인하자',
 npc_reply_neut_9: '거래량 없으면 함정일 수도', npc_reply_neut_10: '손절선 정하고 지켜보자', npc_reply_neut_11: '빨간불엔 분할로 접근한다', npc_reply_neut_12: '이 방 확신이 오히려 불안',
 npc_reply_neut_13: '익절도 계획이 있어야지', npc_reply_neut_14: '지하실 가면 손 안 댄다', npc_reply_neut_15: '멘탈 관리부터 하고 보자', npc_reply_neut_16: '일단 지켜보는 게 상책',
 npc_reply_neut_17: '일단 지켜보는 게 답이다', npc_reply_neut_18: '거래량부터 확인하자', npc_reply_neut_19: '추세 나오면 그때 타자', npc_reply_neut_20: '손절선 정하고 대응하자',
 npc_reply_neut_21: '확신 없으면 쉬는 것도 실력', npc_reply_neut_22: '분할로 접근하는 게 안전', npc_reply_neut_23: '고래 움직임 보고 판단하자', npc_reply_neut_24: '조급하면 지는 게임이다',

 // === 자산 리더보드 ===
 lb_title: '자산 랭킹',
 lb_entry_title: '자산 랭킹',
 lb_entry_sub: '총자산 순위 · 고래들과 경쟁',
 lb_your_rank: '{total}명 중 {rank}위',
 lb_your_assets: '내 총자산',
 lb_best_rank: '최고 {rank}위',
 lb_you: '나',
 lb_footnote: '총자산 = 현금 + 보유 코인 평가액. 랭커들도 계속 자산을 불린다 — 방심하면 밀린다.',

 // === 가짜 리딩방 (Sprint 3a) ===
 lr_title: '리딩방', lr_intro: '방장의 콜을 따라가며 어느 방이 진짜인지 가려내라. 신뢰도는 표시되지 않는다.',
 lr_entry_title: '리딩방 입장', lr_entry_sub: '방장 콜 · 적중률 추적 · 정보상',
 lr_no_call: '대기 중인 콜 없음', lr_no_history: '기록 없음', lr_track_record: '적중 기록',
 lr_hit: '적중', lr_miss: '실패',
 lr_vip_tag: 'VIP', lr_vip_enter: 'VIP 리딩방 입장', lr_vip_sub: '광고 보고 고신뢰 방 입장권',
 lr_vip_unlocked: 'VIP 방 입장 완료', lr_locked_hint: '고신뢰 정예 방 · 입장권 필요',
 // 방 이름 + 방장 소개
 room_newbie: '초보 탈출방', room_newbie_tag: '"묻지마 풀매수! 오늘도 가즈아!"',
 room_diamond: '다이아 홀더방', room_diamond_tag: '"차트 근거로만 콜 드립니다"',
 room_insider: '내부자 정보방', room_insider_tag: '"형님만 믿으세요, 확실한 정보"',
 room_whale: '고래 사관학교', room_whale_tag: '"세력의 움직임을 미리 읽는다"',
 room_oracle: '오라클의 방', room_oracle_tag: '"적중률로 증명합니다"',
 // 방장 콜 문구 (call_up = 매수 유도, call_down = 매도 유도)
 call_up_1: '{coin} 지금 들어가면 2배 간다', call_up_2: '{coin} 곧 상장 정보 입수, 풀매수각',
 call_up_3: '{coin} 세력 매집 포착, 지금이 기회', call_up_4: '{coin} 바닥 다졌다, 추매 콜',
 call_down_1: '{coin} 지금 던져라, 급락 온다', call_down_2: '{coin} 세력 이탈 신호, 손절각',
 call_down_3: '{coin} 고점이다, 익절하고 나와', call_down_4: '{coin} 악재 뜬다, 미리 정리',
 ad_vip_room: 'VIP 리딩방 입장권',

 // === 정보상 (Sprint 3a) ===
 shop_title: '정보상', shop_intro: '거래소 뒷골목. 게임머니로 정보를 판다 — 비싸고, 애매하다.',
 shop_bought: '정보 입수', shop_no_info: '지금은 팔 정보가 없다',
 shop_whale_hint: '세력 동향 귀띔', shop_whale_hint_desc: '움직임이 있는 코인을 하나 짚어준다 (단계까진 모름)',
 shop_news_tip: '다음 소식 코인', shop_news_tip_desc: '다음 뉴스가 어느 코인을 칠지만 (방향은 비밀)',
 shop_room_leak: '리딩방 뒷조사', shop_room_leak_desc: '한 방의 신뢰도 등급을 대략 흘려준다',
 shop_hint_whale: '"{coin}… 요즘 큰손이 붙었다는 소문이 있어"',
 shop_hint_news: '"다음 큰 건은 {coin}쪽에서 터진다더라"',
 shop_hint_room: '"{room}? 그 방 신뢰도는 {band} 수준이야"',
 shop_band_low: '낮음', shop_band_mid: '중간', shop_band_high: '높음',

 // === 리딩방 라이브 채팅 (Sprint 3b) ===
 lrc_quiet: '방이 잠잠하다...',
 rc_me: '나', rc_moon: '가즈아', rc_cut: '손절함', rc_watch: '관망',
 // 옹호/선동
 chat_advocate_1: '가즈아 형님들', chat_advocate_2: '존버는 승리한다',
 chat_advocate_3: '이거 진짜 갑니다 형님들', chat_advocate_4: '지금 안 타면 평생 후회함',
 chat_advocate_5: '풀매수 박았다', chat_advocate_6: '이번엔 느낌이 다르다',
 chat_advocate_7: '홀더는 결국 웃는다', chat_advocate_8: '지금이 마지막 저점이다',
 chat_advocate_9: '떡상 가즈아', chat_advocate_10: '지금 안타면 벼락거지',
 chat_advocate_11: '세력님 저 여기 있어요', chat_advocate_12: '이거 내 시드 다 넣었다',
 chat_advocate_13: '나만 없어 코인', chat_advocate_14: '익절은 예술이다',
 chat_advocate_15: '밈코인은 감성으로 사는거임', chat_advocate_16: '거래량 터졌다 잡아',
 chat_advocate_17: '슈팅 나온다', chat_advocate_18: '골든크로스 떴다',
 chat_advocate_19: '개미의 승리다', chat_advocate_20: '오늘 소고기각',
 chat_advocate_21: '평단 회복 눈앞이다', chat_advocate_22: '이 방 믿고 간다',
 chat_advocate_23: '눌림목에서 담았다', chat_advocate_24: '다음 텐배거 이거다',
 chat_advocate_25: '반등 각 나왔다', chat_advocate_26: '지금이 진짜 저점',
 chat_advocate_27: '초록불 켜졌다', chat_advocate_28: '존버 3년차 웃는다',
 chat_advocate_29: '이 방 믿고 존버 간다', chat_advocate_30: '떨어질 때 줍는 게 실력이다', chat_advocate_31: '세력 붙었다 이번엔 다르다', chat_advocate_32: '물타기로 평단 낮췄다',
 chat_advocate_33: '지금이 마지막 줍줍 찬스', chat_advocate_34: '홀더 인증 여기 있다', chat_advocate_35: '반등 나온다 잡아라 형님들', chat_advocate_36: '이 코인 볼매라 계속 담는다',
 chat_advocate_37: '빨간불이 편안하다 매수각', chat_advocate_38: '고래 매집 들어왔다는데', chat_advocate_39: '존버 3년차 웃을 준비 됐다', chat_advocate_40: '오늘 소고기 먹으러 간다',
 chat_advocate_41: '존버는 승리한다 3년째 믿는 중', chat_advocate_42: '이거 안 사면 벼락거지 각', chat_advocate_43: '치킨값 오늘 여기서 번다', chat_advocate_44: '손가락이 먼저 매수 눌렀다',
 chat_advocate_45: '지금이 저점이다 진짜 이번엔', chat_advocate_46: '떡상 가즈아 심장 준비해', chat_advocate_47: '이 방 콜 이번엔 믿는다', chat_advocate_48: '리딩방 믿고 풀매수 간다',
 chat_advocate_49: '감자농사 접고 여기 왔다', chat_advocate_50: '오늘은 계좌가 효자다',
 // 냉소/의심
 chat_cynic_1: '이상한 소문 흘리지 마라', chat_cynic_2: '물렸냐?',
 chat_cynic_3: '개미털기인 걸 모르네', chat_cynic_4: '탈출은 지능순임',
 chat_cynic_5: '이 방 또 시작이네', chat_cynic_6: '세력 놀음에 놀아나지 마셈',
 chat_cynic_7: '또 펌핑방 도배질', chat_cynic_8: '이런 콜에 사는 놈이 호구',
 chat_cynic_9: '이 방 또 설레발', chat_cynic_10: '희망회로 그만 돌려라',
 chat_cynic_11: '세력이 좋아하겠네', chat_cynic_12: '이 콜 반대로 가면 됨',
 chat_cynic_13: '차트가 심전도냐', chat_cynic_14: '또 물타기 유도한다',
 chat_cynic_15: '먹튀 준비 냄새 난다', chat_cynic_16: '개미 총알받이 모집 중',
 chat_cynic_17: '데드캣에 속지 마라', chat_cynic_18: '설레발이 늘 이렇지',
 chat_cynic_19: '이 방 콜 믿는 놈이 호구', chat_cynic_20: '펌핑방 국룰 나왔다',
 chat_cynic_21: '개미만 태우는 각', chat_cynic_22: '세력 출구 만들어주네',
 chat_cynic_23: '이거 상폐각인데 웃는다', chat_cynic_24: '희망 파는 방이네',
 chat_cynic_25: '또 누가 물렸구나', chat_cynic_26: '거품 걷히면 답 나온다',
 chat_cynic_27: '이 방 매도벽이 세력이다', chat_cynic_28: '결국 개미가 마지막 손',
 chat_cynic_29: '이 방 확신에 찬 게 더 불안하다', chat_cynic_30: '선동 오지네 조심해라 개미들', chat_cynic_31: '물타기 유도하는 냄새 난다', chat_cynic_32: '이 확신은 세력 시나리오다',
 chat_cynic_33: '이 방 콜은 늘 반대로 가더라', chat_cynic_34: '희망 파는 사람만 웃는 방', chat_cynic_35: '또 누가 총알받이 되겠네', chat_cynic_36: '빨간불이 편하다는 정신승리',
 chat_cynic_37: '고래 매집 소리 나오면 조심', chat_cynic_38: '존버 3년차가 자랑이냐', chat_cynic_39: '소고기는 세력만 먹는다', chat_cynic_40: '이 방 믿다가 라면 각이다',
 chat_cynic_41: '이 방 또 설거지 시작이네', chat_cynic_42: '탈출은 지능순임 여긴 아니고', chat_cynic_43: '치킨값 벌려다 치킨집 넘길 각', chat_cynic_44: '리딩방 믿는 순간 호구 확정',
 chat_cynic_45: '지금이 저점이다 3일째 그 소리', chat_cynic_46: '손가락이 매수 누르게 유도하네', chat_cynic_47: '이 방 콜 반대로 가면 됨 국룰', chat_cynic_48: '세력 설거지판에 그릇 대주지 마라',
 chat_cynic_49: '감자농사가 나은 걸 여기서 깨닫는다', chat_cynic_50: '벼락거지 코스 안내방이네 여기',
 // 패닉/자조
 chat_panic_1: '나만 물렸나', chat_panic_2: '손절각인가',
 chat_panic_3: '이거 상폐각인데', chat_panic_4: '존버하다 순삭당함',
 chat_panic_5: '내 시드 어디감', chat_panic_6: '원금 반토막 났다',
 chat_panic_7: '이래서 코인 하면 안 되는데', chat_panic_8: '멘탈 나갔다 진짜',
 chat_panic_9: '라면이나 끓이러 간다', chat_panic_10: '계좌가 녹는다',
 chat_panic_11: '물렸는데 존버 각인가요', chat_panic_12: '내 계좌 초토화',
 chat_panic_13: '오늘도 눈물의 라면', chat_panic_14: '반등 기다리다 늙는다',
 chat_panic_15: '손절 버튼이 안 눌린다', chat_panic_16: '희망은 사치였다',
 chat_panic_17: '벼락거지 되는 중', chat_panic_18: '이 코인 답이 없다',
 chat_panic_19: '개미 지옥 오픈했다', chat_panic_20: '고점 대비 반토막',
 chat_panic_21: '물타기하다 다 잃었다', chat_panic_22: '지지선 뚫렸다 어카냐',
 chat_panic_23: '멘탈 관리가 안 된다', chat_panic_24: '오늘도 파란불 파티',
 chat_panic_25: '탈출 타이밍 놓쳤다', chat_panic_26: '존버가 이렇게 힘들 줄',
 chat_panic_27: '내 시드 순삭됐다', chat_panic_28: '이제 기도만 남았다',
 chat_panic_29: '이 방 따라 물타기했다 더 물렸다', chat_panic_30: '내 시드가 녹고 있어 진짜', chat_panic_31: '나만 고점에 물린 거냐', chat_panic_32: '손절 못 하고 여기까지 왔다',
 chat_panic_33: '본전 오면 나간다더니 못 나간다', chat_panic_34: '고래가 던지고 나갔다는데 어카냐', chat_panic_35: '익절한 사람만 사람이었네', chat_panic_36: '차트가 지하실 판다 무섭다',
 chat_panic_37: '멘탈싸움에서 나가떨어졌다', chat_panic_38: '이 방 분위기 초상집 됐다', chat_panic_39: '오늘도 계좌 보기가 무섭다', chat_panic_40: '존버 3년차 아직도 마이너스',
 chat_panic_41: '나만 물렸지 나만 물렸구나', chat_panic_42: '치킨값 벌려다 치킨집 넘겼다', chat_panic_43: '물타기하다 그냥 익사했다', chat_panic_44: '내 시드 어디갔나요 진심으로',
 chat_panic_45: '리딩방 믿은 내가 바보였다', chat_panic_46: '손절 버튼이 물리적으로 안 눌린다', chat_panic_47: '지금이 저점이다 3일째 우는 중', chat_panic_48: '탈출은 지능순인데 나는 아니었네',
 chat_panic_49: '감자농사 할걸 진짜 후회된다', chat_panic_50: '벼락거지 코스 정상 진행 중이다',
 // 훈수/분석
 chat_analysis_1: '차트 보면 답 나옴', chat_analysis_2: '거래량 실리는 거 봐라',
 chat_analysis_3: '저점 잡아라', chat_analysis_4: '지금 물타기 타이밍',
 chat_analysis_5: '지지선 지켜주네', chat_analysis_6: '이평선 골든크로스 각',
 chat_analysis_7: '분할 매수가 정석이다', chat_analysis_8: '거래량 없으면 눌림목',
 chat_analysis_9: '세력 매집 흔적 보인다', chat_analysis_10: '차트가 우상향 그린다',
 chat_analysis_11: '저항선 돌파하면 슈팅', chat_analysis_12: '거래량 터지면 진짜다',
 chat_analysis_13: '단타는 손절선 지켜라', chat_analysis_14: '데드캣 조심하고 관망',
 chat_analysis_15: '눌림목 매수가 정답', chat_analysis_16: '이평선 정배열 됐다',
 chat_analysis_17: '박스권 상단 저항이다', chat_analysis_18: '거래량 없으면 진입 금지',
 chat_analysis_19: '세력 매물대 확인해라', chat_analysis_20: '분할 매도로 리스크 관리',
 chat_analysis_21: '차트 심리가 중요하다', chat_analysis_22: '고점에서 물량 나온다',
 chat_analysis_23: '지지선 이탈하면 손절', chat_analysis_24: '추세 살아있으면 홀드',
 chat_analysis_25: '변동성 클 땐 관망', chat_analysis_26: '세력 사이클 읽어라',
 chat_analysis_27: '거래량 죽으면 하락각', chat_analysis_28: '리스크 관리가 실력이다',
 chat_analysis_29: '이 확신엔 근거가 없어 관망각', chat_analysis_30: '물타기는 추세 확인하고 해라', chat_analysis_31: '고래 지갑 움직임부터 봐라', chat_analysis_32: '거래량 없는 반등은 함정이다',
 chat_analysis_33: '손절선 정하고 들어가는 거다', chat_analysis_34: '빨간불에 담을 땐 분할로 해라', chat_analysis_35: '본전 심리에 물타기 금물이다', chat_analysis_36: '세력 매집설은 검증부터 해라',
 chat_analysis_37: '익절도 계획이 있어야 한다', chat_analysis_38: '지하실 갈 땐 손 대지 마라', chat_analysis_39: '멘탈 관리가 곧 리스크 관리다', chat_analysis_40: '확신이 강한 방일수록 의심해라',
 chat_analysis_41: '리딩방 콜은 근거부터 확인해라', chat_analysis_42: '저점이라는 말 3일째면 저점 아니다', chat_analysis_43: '물타기 전에 추세부터 봐라 익사한다', chat_analysis_44: '손절선 정하고 들어가야 벼락거지 안 된다',
 chat_analysis_45: '세력 설거지 신호는 거래량에 나온다', chat_analysis_46: '탈출은 지능순이니 계획부터 세워라', chat_analysis_47: '치킨값 노리다 시드 다 태운다 분할해라', chat_analysis_48: '고래 지갑 움직임부터 체크해라',
 chat_analysis_49: '반등각은 거래량 실릴 때만 진짜다', chat_analysis_50: '익절은 예술 손절은 기술 둘 다 계획이다',
 // NPC 에코 (내 리액션에 대한 반응)
 chat_echo_up_1: '가즈아 나도 간다', chat_echo_up_2: '형님만 믿는다',
 chat_echo_up_3: '풀매수 동참', chat_echo_up_4: '설레발은 금물인데',
 chat_echo_up_5: '형만 믿고 풀매수 간다', chat_echo_up_6: '나도 떨어질 때 줍줍했다', chat_echo_up_7: '세력 붙었으면 게임 끝', chat_echo_up_8: '빨간불이라 더 담았다',
 chat_echo_up_9: '존버 각 나도 잡았다', chat_echo_up_10: '이번엔 느낌 좋다 가자', chat_echo_up_11: '물타기로 평단 낮췄다', chat_echo_up_12: '소고기 먹을 준비 하자',
 chat_echo_up_13: '고래 매집이면 진짜다', chat_echo_up_14: '익절 타이밍만 잘 잡자', chat_echo_up_15: '이 방 오랜만에 확신 든다', chat_echo_up_16: '반등각 잡았다 가즈아',
 chat_echo_down_1: '나도 손절했다', chat_echo_down_2: '겁쟁이는 도망부터',
 chat_echo_down_3: '현명한 선택', chat_echo_down_4: '아직 버틴다 나는',
 chat_echo_down_5: '나도 손절이 답이었다', chat_echo_down_6: '고점에 물린 게 나만 아니네', chat_echo_down_7: '시드 녹는 소리 들린다', chat_echo_down_8: '희망회로 그만 돌린다',
 chat_echo_down_9: '익절한 사람만 이겼네', chat_echo_down_10: '본전은 물 건너갔다', chat_echo_down_11: '라면 각이다 오늘도', chat_echo_down_12: '세력이 다 털고 나갔다',
 chat_echo_down_13: '지하실 파는 차트 무섭다', chat_echo_down_14: '멘탈싸움에서 졌다', chat_echo_down_15: '손절 버튼이 안 눌린다', chat_echo_down_16: '현명하게 발 뺐다 나는',
 chat_echo_neut_1: '관망도 실력이지', chat_echo_neut_2: '지켜보자고',
 chat_echo_neut_3: '결정 못 하면 지는 거임', chat_echo_neut_4: '나도 일단 대기',
 chat_echo_neut_5: '확신 들 때까지 관망', chat_echo_neut_6: '근거 없는 확신은 위험해', chat_echo_neut_7: '물타기는 추세 보고', chat_echo_neut_8: '고래 움직임부터 확인',
 chat_echo_neut_9: '거래량 없으면 함정일 수도', chat_echo_neut_10: '손절선 정하고 지켜본다', chat_echo_neut_11: '빨간불엔 분할로 접근', chat_echo_neut_12: '확신이 오히려 불안하다',
 chat_echo_neut_13: '익절도 계획이 있어야지', chat_echo_neut_14: '지하실 가면 손 안 댄다', chat_echo_neut_15: '멘탈 관리부터 하자', chat_echo_neut_16: '일단 지켜보는 게 상책',
 // 소문 (진위 숨겨짐)
 rumor_tag: '소문', rumor_true: '진짜', rumor_fake: '거짓',
 rumor_check_btn: '진위 확인', rumor_check_sub: '광고 보고 팩트체크',
 rumor_listing_1: '{coin} 대형 거래소 상장 정보 입수했다', rumor_listing_2: '{coin} 바이낸스 상장 곧 뜬다더라',
 rumor_listing_3: '{coin} 상장 공지 초읽기 들어갔다', rumor_listing_4: '{coin} 메이저 거래소 심사 통과했대',
 rumor_listing_5: '{coin} 상장 리크 내부에서 돌고 있다', rumor_listing_6: '{coin} 상장 확정 소식 방금 들었다',
 rumor_listing_7: '{coin} 상장 임박이라 미리 담는 중', rumor_listing_8: '{coin} 거래소 상장 D-1이라던데',
 rumor_accumulate_1: '세력이 {coin} 매집 끝냈다더라', rumor_accumulate_2: '{coin} 큰손들이 조용히 물량 쓸어담는다',
 rumor_accumulate_3: '{coin} 세력 매집 마무리 단계란다', rumor_accumulate_4: '고래 지갑이 {coin} 계속 빨아들이는 중',
 rumor_accumulate_5: '{coin} 유통 물량 세력이 다 잠갔다더라', rumor_accumulate_6: '{coin} 매집 끝나면 펌핑 온다던데',
 rumor_accumulate_7: '{coin} 세력 평단 밑에서 줍줍 중이래', rumor_accumulate_8: '{coin} 물량 잠기고 있다 슬슬 탈 때',
 rumor_partnership_1: '{coin} 대기업 제휴 발표 임박이래', rumor_partnership_2: '{coin} 글로벌 파트너십 곧 공개된다더라',
 rumor_partnership_3: '{coin} 유명 기업이랑 협업 준비 중이란다', rumor_partnership_4: '{coin} 대형 제휴 뉴스 방금 흘러나왔다',
 rumor_partnership_5: '{coin} 메인넷 파트너 발표 초읽기래', rumor_partnership_6: '{coin} 결제 도입 제휴 곧 터진다던데',
 rumor_partnership_7: '{coin} 빅테크 협약 사인 직전이래', rumor_partnership_8: '{coin} 제휴 공시 뜨기 전에 담는 중',
 rumor_delist_1: '{coin} 내일 거래소 상폐된대', rumor_delist_2: '{coin} 상폐 심사 들어갔다더라',
 rumor_delist_3: '{coin} 거래지원 종료 공지 뜬단다', rumor_delist_4: '{coin} 유의종목 지정될 거란 소문이다',
 rumor_delist_5: '{coin} 상폐 리스트에 올랐다던데', rumor_delist_6: '거래소가 {coin} 정리한다더라',
 rumor_delist_7: '{coin} 상폐 예고 곧 나온다 던져라', rumor_delist_8: '{coin} 상장폐지 초읽기라던데 조심',
 rumor_rugpull_1: '{coin} 개발자 먹튀 준비 중이라던데', rumor_rugpull_2: '{coin} 팀 지갑이 물량 빼고 있다더라',
 rumor_rugpull_3: '{coin} 개발진 잠수 탔다는 소문이다', rumor_rugpull_4: '{coin} 유동성 빠지는 거 포착됐다던데',
 rumor_rugpull_5: '{coin} 러그풀 조짐 보인다 손 떼라', rumor_rugpull_6: '{coin} 컨트랙트 이상하다는 얘기 돈다',
 rumor_rugpull_7: '{coin} 개발자 지갑 이동 감지됐대', rumor_rugpull_8: '{coin} 먹튀각이라 다들 던지는 중',
 rumor_dump_1: '세력이 {coin} 물량 던진다더라', rumor_dump_2: '{coin} 고래가 매도벽 쌓는 중이란다',
 rumor_dump_3: '{coin} 세력 설거지 시작됐다던데', rumor_dump_4: '{coin} 큰손들 슬슬 던지고 나가는 중',
 rumor_dump_5: '{coin} 덤핑 물량 대기 중이라더라', rumor_dump_6: '{coin} 세력이 개미한테 넘기고 튄다',
 rumor_dump_7: '{coin} 매도 폭탄 곧 떨어진다던데', rumor_dump_8: '{coin} 지금 안 팔면 물린다 던져라',
} as Record<string, string>;
